import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "features/store";

type ProtectedRouteProps = {
  children: JSX.Element;
};

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isAuthenticated && user && !user.is_pass_reset) {
    return <Navigate to="/reset-password" replace />;
  }

  const pp = user?.platform_profile;

  if (pp?.is_archived) {
    return <Navigate to="/login" replace />;
  }

  if (location.pathname === "/chat") {
    const canChat = pp?.is_ai_agent_user;
    if (user && !canChat) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
